export const getProjectLinks = (state) => {
  return state.pages.projectView.project.links;
};
